// extracted by mini-css-extract-plugin
export default {"help-btn":"practices-admin_help-btn__AejD2"};